// Small synthesized sounds (no audio files): a soft chime and gentle ocean waves
let ctx = null;
const audio = () => {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

export const chime = (pitch = 528) => {
  const a = audio(), t = a.currentTime;
  [pitch, pitch * 1.5].forEach((f, i) => {
    const o = a.createOscillator(), g = a.createGain();
    o.type = "sine"; o.frequency.value = f;
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(i ? 0.03 : 0.08, t + 0.04);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 2.2);
    o.connect(g).connect(a.destination);
    o.start(t); o.stop(t + 2.3);
  });
};

export const startWaves = () => {
  const a = audio(), len = a.sampleRate * 4, buf = a.createBuffer(1, len, a.sampleRate), d = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i += 1) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.5; }
  const src = a.createBufferSource(), lp = a.createBiquadFilter(), g = a.createGain(), lfo = a.createOscillator(), depth = a.createGain();
  src.buffer = buf; src.loop = true;
  lp.type = "lowpass"; lp.frequency.value = 700;
  g.gain.value = 0.12; lfo.frequency.value = 0.12; depth.gain.value = 0.09;
  lfo.connect(depth).connect(g.gain);
  src.connect(lp).connect(g).connect(a.destination);
  src.start(); lfo.start();
  return () => { g.gain.setTargetAtTime(0, a.currentTime, 0.4); setTimeout(() => { src.stop(); lfo.stop(); }, 1500); };
};
